export const headerStrings = {
    en:{
        headerHome:"Home",
        headerAboutMe:"About Me",
        headerWhatIDo:"What I Do",
        headerEducation:"Education",
        headerExperience:"Experience",
        headerSkills:"Skills",
        headerPortfolio:"Portfolio",
        headerTestimonial:"Testimonial",
        headerContact:"Contact",
    },
    pl: {
        headerHome:"Start",
        headerAboutMe:"O mnie",
        headerWhatIDo:"Czym się zajmuję",
        headerEducation:"Wykształcenie",
        headerExperience:"Doświadczenie",
        headerSkills:"Umiejętności",
        headerPortfolio:"Portfolio",
        headerTestimonial:"Opinie",
        headerContact:"Kontakt",
    },
};

export default headerStrings;